import React, { Fragment, useState } from 'react'
import { formatDbDate } from '../../utils/dateFormater';
import { formatWhatsAppNumber } from '../../utils/whatsappLinkFormater';
import SingleOrderButtons from './SingleOrderButtons';

const SingleReservation = ({ order, user, selectedOrders, setSelectedOrders }) => {




    const [copied, setCopied] = useState(false);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };











    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }











    return (
        <Fragment>
            <div 
                className="grid py-[1vmax] items-center border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                style={{ gridTemplateColumns: user?.role !== 'PM' 
                    ? 'minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 1.8fr) minmax(0, 1.5fr) minmax(0, 1.5fr)' 
                    : 'minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.8fr) minmax(0, 1.5fr) minmax(0, 1.5fr)' }}
            >
                {/* Select */}
                <div className="flex-center text-zinc-700 text-[1.3vmax] lg:text-[0.9vmax] font-jakarta" >
                    <input
                        type="checkbox"
                        className="w-4 h-4 text-indigo-600 border-zinc-300 rounded focus:ring-indigo-500 cursor-pointer"
                        checked={selectedOrders?.includes(order.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectedOrders(prev => [...prev, order.id]);
                            } else {
                                setSelectedOrders(prev => prev.filter(id => id !== order.id));
                            }
                        }}
                    />
                </div>

                {/* Order ID */}
                <div className="text-center text-zinc-700 font-bold text-[1.3vmax] lg:text-[0.9vmax] font-jakarta" >
                    #{order?.id}
                </div>

                {/* Product ID */}
                <div className="flex-center text-zinc-700 text-[1.3vmax] lg:text-[0.9vmax] flex gap-[0.5vmax] items-center font-jakarta" >
                    <span className="text-zinc-600 font-medium" >
                        {order?.product_id}
                    </span>
                    <button
                        onClick={() => handleCopy(order?.product_id)}
                        className="text-zinc-400 hover:text-zinc-600 transition-colors text-sm"
                        title={copied ? "Copied" : "Copy"}
                    >
                        <i className={`fa-regular ${copied ? "fa-circle-check text-emerald-500" : "fa-copy"}`}></i>
                    </button>
                </div>

                {/* Ordered By */}
                <div className="flex-center text-zinc-700 text-[1.3vmax] lg:text-[0.9vmax] font-jakarta" >
                    <a href={formatWhatsAppNumber(order?.pm_country_code, order?.pm_phone_number)} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center hover:text-indigo-600 transition-colors">
                        <i className="fa-brands fa-whatsapp text-emerald-500 text-[2.5vmax] lg:text-[1.5vmax]"></i>
                        <span className="font-bold text-zinc-800 text-[1.3vmax] lg:text-[0.9vmax] mt-1">{order?.pm_name}</span>
                    </a>
                </div>

                {/* PM Earnings */}
                <div className="text-center text-zinc-700 font-semibold text-[1.3vmax] lg:text-[0.9vmax] font-jakarta" >
                    {order?.pm_commission_amount ? `Rs. ${order?.pm_commission_amount}` : "Rs. 0.00"}
                </div>

                {/* Portal Earnings */}
                {user?.role !== "PM" &&
                    <div className="text-center text-zinc-700 font-semibold text-[1.3vmax] lg:text-[0.9vmax] font-jakarta" >
                        {order?.portal_commission_amount ? `Rs. ${order?.portal_commission_amount}` : "Rs. 0.00"}
                    </div>
                }

                {/* Commissioned At */}
                <div className="text-center text-zinc-500 text-[1.3vmax] lg:text-[0.9vmax] font-jakarta whitespace-nowrap" >
                    {formatDbDate(order?.updated_at)}
                </div>

                {/* Status */}
                <div className="flex-center" >
                    <span className={`text-[1.3vmax] lg:text-[0.85vmax] font-jakarta font-semibold uppercase px-3 py-1 rounded-full ${handleClassName(order?.status)}`}>
                        {order?.status}
                    </span>
                </div>

                {/* Actions */}
                <div className="flex-center">
                    <SingleOrderButtons order={order} user={user} />
                </div>
            </div>
        </Fragment>
    )
}

export default SingleReservation